 <div class="modal-header" [attr.data-bs-theme]="darkModeService.darkModeSignal()">
    <h4 class="modal-title text-primary">Update group</h4>
      <i class="fa fa-2x fa-times text-primary" (click)="modalRef.hide()"></i>
  </div>

  <div class="modal-body" [attr.data-bs-theme]="darkModeService.darkModeSignal()">
    <form class="row" [formGroup]="updateGroupForm">

      <div class="col-md-6">
        <label>Id</label>
        <input type="text" class="form-control" formControlName="id">
      </div>

      <div class="col-md-18">
        <label>Name</label>
        <input type="text" class="form-control" formControlName="name">
      </div>

    </form>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-outline-primary" (click)="modalRef.hide()">Cancel</button>
    <button type="submit" class="btn btn-primary" (click)="update()">Save Group</button>
  </div>

